export const EVENTS_SCHEMA_VERSION = "0.49.0";
export const PAGE_VIEWS_SCHEMA_VERSION = "0.22.0";
